import React, { useEffect } from "react";
import { useLazyGetTransactionsFilteredQuery } from "../../../features/transactions/transactionsApiSlice";

const DropdownOptionsFetcher = ({ permanentFilters = {}, onDataFetched }) => {
  const [fetchTransactions, { data, isLoading }] = useLazyGetTransactionsFilteredQuery();

  useEffect(() => {
    // Fetch data ONLY with permanent filters (not user-applied filters)
    // This ensures dropdown options show all available values within user's permissions
    fetchTransactions({ page: 1, limit: 99999, filters: permanentFilters });
  }, [permanentFilters, fetchTransactions]);

  useEffect(() => {
    if (data && onDataFetched) {
      onDataFetched(data);
    }
  }, [data, onDataFetched]);

  return null; // no UI rendered
};

export default DropdownOptionsFetcher;

